import { createFileRoute } from '@tanstack/react-router'
import { TeamChatPage } from '@/features/team-chat/components/TeamChatPage'

export const Route = createFileRoute('/_auth/chat')({
  component: TeamChatPage,
})
